import React from "react";
import GeneralAnchor from "../general-anchor/general-anchor.component";
import Calculator from "../../assets/calculator.inline.svg";
import NewWindow from "../../assets/new_window.inline.svg";
import { triggerTealiumEvent } from "../../utils/tealiumUtils";
import { useLocation } from "@reach/router";

const AffordabilityCalculator = ({ children }) => {
  const location = useLocation();
  
  const handleClick = (calculatorType) => {
    triggerTealiumEvent(
      "link",
      location.href,
      "content",
      "button",
      calculatorType,
      "product information",
      "Home",
      "10451v6"
    );
  };

  return (
    <section className="affordability-calculator">
      <div className="affordability-calculator__texts">
        <Calculator />
        <h2>Calculators</h2>
        <p>Find out how much your customer may be able to borrow with these quick and easy-to-use calculators.</p>
      </div>
      <div className="affordability-calculator__buttons">
        <GeneralAnchor
          isBlank
          href="https://www.hsbc.co.uk/services/global-mortgages/ntb/affordability-calculator/"
          rel="noreferrer"
          isLink={true}
          additionalClass="residential-calculator"
          onClick={() => handleClick("Launch Residential calculator")}
        >
          Launch Residential calculator
          <NewWindow />
        </GeneralAnchor>
        <GeneralAnchor
          isBlank
          href="https://www.hsbc.co.uk/services/global-mortgages/ntb/btl-calculator/"
          rel="noreferrer"
          isLink={true}
          onClick={() => handleClick("Launch Buy to let calculator")}
        >
          Launch Buy to let calculator
          <NewWindow />
        </GeneralAnchor>
        {children && children}
      </div>
    </section>
  );
};

export default AffordabilityCalculator;
